import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=49e2a515&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=49e2a515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e2a515",
  null
  
)

export default component.exports